import { PlayerRef } from '@remotion/player';
import { useEffect, useRef } from 'react';

export function useAutoplayOnce({
  autoPlay,
  playerRef,
  play
}: {
  autoPlay: boolean;
  playerRef: PlayerRef | null;
  play: () => void;
}): void {
  const hasAutoPlayedRef = useRef(false);

  useEffect(() => {
    if (!autoPlay || hasAutoPlayedRef.current || !playerRef) {
      return;
    }
    hasAutoPlayedRef.current = true;
    play();
  }, [autoPlay, play, playerRef]);
}
